<div class="layout-vbox" style="height: 100%">
    <h3>UW Portfolio Library</h3>
    @if (uwYears().length > 0) {
        <wj-tab-panel #tabPanel [isAnimated]="true" class="custom-tab tabs-left full-size-ver" style="flex: 1"
                      [selectedIndex]="selectedTabIndex()"
                      (selectedIndexChanged)="onSelectedTabIndexChanged(tabPanel)"
        >
            @for (uwyear of uwYears(); track uwyear) {
                <wj-tab>
                    <a>{{uwyear}}</a>
                    <div>
                        <div appIntersectionObserver (intersectionCallback)="onYearTabIntersection(uwyear)" style="padding: 10px;">
                            @let track = yearlyGroups(uwyear).tracking();
                            @let tier = yearlyGroups(uwyear).tiering();

                            <h4 class="phase-header" style="margin-top: 0">Tracking</h4>
                            @if (track.length == 0) {
                                <div class="empty-card-container">There are no items in this phase and this UWY</div>
                            } @else {
                                <div class="card-container">
                                    @for (item of track; track item.portfolioModel.id) {
                                        <app-app-portfolio-card [item]="item"></app-app-portfolio-card>
                                    }
                                </div>
                            }

                            <h4 class="phase-header">Tiering</h4>
                            @if (tier.length == 0) {
                                <div class="empty-card-container">There are no items in this phase and this UWY</div>
                            } @else {
                                <div class="card-container">
                                    @for (item of tier; track item.portfolioModel.id) {
                                        <app-app-portfolio-card [item]="item"></app-app-portfolio-card>
                                    }
                                </div>
                            }

                            <!--
                            @let plan = yearlyGroups(uwyear).planning();
                            <h4 class="phase-header">Planning</h4>
                            @if (plan.length == 0) {
                                <div class="empty-card-container">There are no items in this phase and this UWY</div>
                            } @else {
                                <div class="card-container">
                                    @for (item of plan; track item.portfolioModel.id) {
                                        <app-app-portfolio-card [item]="item"></app-app-portfolio-card>
                                    }
                                </div>
                            }
                            -->
                        </div>
                    </div>
                </wj-tab>
            }
        </wj-tab-panel>
    }
</div>
